import { render, staticRenderFns } from "./AddGood.vue?vue&type=template&id=bc45acfc&scoped=true&"
import script from "./AddGood.vue?vue&type=script&lang=js&"
export * from "./AddGood.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=bc45acfc&prod&scoped=true&lang=css&"
import style1 from "./AddGood.vue?vue&type=style&index=1&id=bc45acfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc45acfc",
  null
  
)

export default component.exports